var render = function () {
  var _vm$work, _vm$work2, _vm$work3, _vm$work3$program, _vm$work4, _vm$work4$program, _vm$work5, _vm$work6, _vm$work6$author, _vm$work6$author$name, _vm$work7, _vm$work8, _vm$work9, _vm$work10, _vm$work11, _vm$work11$price_esti, _vm$work11$price_esti2, _vm$work11$price_esti3, _vm$work12, _vm$work12$price_esti, _vm$work12$price_esti2, _vm$work12$price_esti3, _vm$work13, _vm$work13$price_auct, _vm$work13$price_auct2, _vm$work13$price_auct3, _vm$work14, _vm$work14$price_auct, _vm$work14$price_auct2, _vm$work14$price_auct3, _vm$work15, _vm$work15$price_esti, _vm$work15$price_esti2, _vm$work15$price_esti3, _vm$work16, _vm$work16$price_esti, _vm$work16$price_esti2, _vm$work16$price_esti3, _vm$work17, _vm$work17$price_auct, _vm$work17$price_auct2, _vm$work17$price_auct3, _vm$work18, _vm$work18$price_auct, _vm$work18$price_auct2, _vm$work18$price_auct3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-14"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7",
      "align-self": "center"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('bids-item-imgs', {
    attrs: {
      "imgs": (_vm$work = _vm.work) === null || _vm$work === void 0 ? void 0 : _vm$work.imgs
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "pl-16 pl-md-20"
  }, [_c('div', {
    staticClass: "mb-8 mb-md-10"
  }, [_c('span', {
    staticClass: "font-size-14 font-weight-medium primary--text"
  }, [_vm._v(" " + _vm._s((_vm$work2 = _vm.work) === null || _vm$work2 === void 0 ? void 0 : _vm$work2.auctionCategoryText) + " "), ((_vm$work3 = _vm.work) === null || _vm$work3 === void 0 ? void 0 : (_vm$work3$program = _vm$work3.program) === null || _vm$work3$program === void 0 ? void 0 : _vm$work3$program.subject) ? _c('span', [_c('span', [_vm._v(" - ")]), _vm._v(_vm._s((_vm$work4 = _vm.work) === null || _vm$work4 === void 0 ? void 0 : (_vm$work4$program = _vm$work4.program) === null || _vm$work4$program === void 0 ? void 0 : _vm$work4$program.subject))]) : _vm._e()])]), _c('div', {
    staticClass: "d-flex flex-wrap align-center"
  }, [_c('v-chip', {
    staticClass: "rounded-0 mr-8",
    attrs: {
      "outlined": "",
      "small": ""
    }
  }, [_vm._v(_vm._s((_vm$work5 = _vm.work) === null || _vm$work5 === void 0 ? void 0 : _vm$work5.lot))]), _c('strong', {
    staticClass: "font-size-16 font-size-md-18"
  }, [_vm._v(_vm._s((_vm$work6 = _vm.work) === null || _vm$work6 === void 0 ? void 0 : (_vm$work6$author = _vm$work6.author) === null || _vm$work6$author === void 0 ? void 0 : (_vm$work6$author$name = _vm$work6$author.name) === null || _vm$work6$author$name === void 0 ? void 0 : _vm$work6$author$name.ko))])], 1), _c('div', {
    staticClass: "mt-2 mt-md-4"
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v(_vm._s((_vm$work7 = _vm.work) === null || _vm$work7 === void 0 ? void 0 : _vm$work7.subject))])]), _c('div', {
    staticClass: "mt-8 mt-md-10"
  }, [_c('div', {
    staticClass: "font-size-14 line-height-13 grey-68--text"
  }, [_vm._v(_vm._s((_vm$work8 = _vm.work) === null || _vm$work8 === void 0 ? void 0 : _vm$work8.year)), _c('br'), _vm._v(_vm._s((_vm$work9 = _vm.work) === null || _vm$work9 === void 0 ? void 0 : _vm$work9.material) + " ㅣ " + _vm._s((_vm$work10 = _vm.work) === null || _vm$work10 === void 0 ? void 0 : _vm$work10.dimensionTag))])])])])], 1)], 1), _c('v-col', {
    staticClass: "d-none d-md-block",
    staticStyle: {
      "margin-left": "-1px"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "grey-da",
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5",
      "align-self": "center"
    }
  }, [_c('div', {
    staticClass: "font-size-14 py-10 pa-md-20 pl-md-40"
  }, [_vm.isPrivate ? [_c('v-btn', {
    attrs: {
      "to": "/auction-works/".concat(_vm.work._id),
      "small": "",
      "block": "",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-xl-16"
  }, [_vm._v("문의하기")])])] : _vm._e(), _vm.isProgram ? [_vm.work.isAuctionEnded ? [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("추정가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work11 = _vm.work) === null || _vm$work11 === void 0 ? void 0 : (_vm$work11$price_esti = _vm$work11.price_estimated) === null || _vm$work11$price_esti === void 0 ? void 0 : (_vm$work11$price_esti2 = _vm$work11$price_esti.from) === null || _vm$work11$price_esti2 === void 0 ? void 0 : (_vm$work11$price_esti3 = _vm$work11$price_esti2.format) === null || _vm$work11$price_esti3 === void 0 ? void 0 : _vm$work11$price_esti3.call(_vm$work11$price_esti2)) || "0") + " ~ " + _vm._s(((_vm$work12 = _vm.work) === null || _vm$work12 === void 0 ? void 0 : (_vm$work12$price_esti = _vm$work12.price_estimated) === null || _vm$work12$price_esti === void 0 ? void 0 : (_vm$work12$price_esti2 = _vm$work12$price_esti.to) === null || _vm$work12$price_esti2 === void 0 ? void 0 : (_vm$work12$price_esti3 = _vm$work12$price_esti2.format) === null || _vm$work12$price_esti3 === void 0 ? void 0 : _vm$work12$price_esti3.call(_vm$work12$price_esti2)) || ""))])])], 1), _c('v-row', {
    staticClass: "mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("시작가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work13 = _vm.work) === null || _vm$work13 === void 0 ? void 0 : (_vm$work13$price_auct = _vm$work13.price_auction) === null || _vm$work13$price_auct === void 0 ? void 0 : (_vm$work13$price_auct2 = _vm$work13$price_auct.from) === null || _vm$work13$price_auct2 === void 0 ? void 0 : (_vm$work13$price_auct3 = _vm$work13$price_auct2.format) === null || _vm$work13$price_auct3 === void 0 ? void 0 : _vm$work13$price_auct3.call(_vm$work13$price_auct2)) || "0"))])])], 1), _c('v-row', {
    staticClass: "font-weight-medium mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("낙찰가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work14 = _vm.work) === null || _vm$work14 === void 0 ? void 0 : (_vm$work14$price_auct = _vm$work14.price_auction) === null || _vm$work14$price_auct === void 0 ? void 0 : (_vm$work14$price_auct2 = _vm$work14$price_auct.current) === null || _vm$work14$price_auct2 === void 0 ? void 0 : (_vm$work14$price_auct3 = _vm$work14$price_auct2.format) === null || _vm$work14$price_auct3 === void 0 ? void 0 : _vm$work14$price_auct3.call(_vm$work14$price_auct2)) || "0"))])])], 1), _c('div', {
    staticClass: "mt-10 mt-md-16"
  }, [_c('v-btn', {
    staticClass: "grey-cb--text",
    attrs: {
      "to": "/auction-works/".concat(_vm.work._id),
      "small": "",
      "block": "",
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-xl-16 primary--text"
  }, [_vm._v("상세보기")])])], 1)] : [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("추정가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work15 = _vm.work) === null || _vm$work15 === void 0 ? void 0 : (_vm$work15$price_esti = _vm$work15.price_estimated) === null || _vm$work15$price_esti === void 0 ? void 0 : (_vm$work15$price_esti2 = _vm$work15$price_esti.from) === null || _vm$work15$price_esti2 === void 0 ? void 0 : (_vm$work15$price_esti3 = _vm$work15$price_esti2.format) === null || _vm$work15$price_esti3 === void 0 ? void 0 : _vm$work15$price_esti3.call(_vm$work15$price_esti2)) || "0") + " ~ " + _vm._s(((_vm$work16 = _vm.work) === null || _vm$work16 === void 0 ? void 0 : (_vm$work16$price_esti = _vm$work16.price_estimated) === null || _vm$work16$price_esti === void 0 ? void 0 : (_vm$work16$price_esti2 = _vm$work16$price_esti.to) === null || _vm$work16$price_esti2 === void 0 ? void 0 : (_vm$work16$price_esti3 = _vm$work16$price_esti2.format) === null || _vm$work16$price_esti3 === void 0 ? void 0 : _vm$work16$price_esti3.call(_vm$work16$price_esti2)) || ""))])])], 1), _c('v-row', {
    staticClass: "mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("시작가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work17 = _vm.work) === null || _vm$work17 === void 0 ? void 0 : (_vm$work17$price_auct = _vm$work17.price_auction) === null || _vm$work17$price_auct === void 0 ? void 0 : (_vm$work17$price_auct2 = _vm$work17$price_auct.from) === null || _vm$work17$price_auct2 === void 0 ? void 0 : (_vm$work17$price_auct3 = _vm$work17$price_auct2.format) === null || _vm$work17$price_auct3 === void 0 ? void 0 : _vm$work17$price_auct3.call(_vm$work17$price_auct2)) || "0"))])])], 1), _c('v-row', {
    staticClass: "font-weight-medium mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', [_vm._v("현재가")])]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "pl-sm-12"
  }, [_vm._v("KRW " + _vm._s(((_vm$work18 = _vm.work) === null || _vm$work18 === void 0 ? void 0 : (_vm$work18$price_auct = _vm$work18.price_auction) === null || _vm$work18$price_auct === void 0 ? void 0 : (_vm$work18$price_auct2 = _vm$work18$price_auct.current) === null || _vm$work18$price_auct2 === void 0 ? void 0 : (_vm$work18$price_auct3 = _vm$work18$price_auct2.format) === null || _vm$work18$price_auct3 === void 0 ? void 0 : _vm$work18$price_auct3.call(_vm$work18$price_auct2)) || "0"))])])], 1), _c('div', {
    staticClass: "mt-10 mt-md-16"
  }, [_c('v-btn', {
    attrs: {
      "to": "/auction-works/".concat(_vm.work._id),
      "small": "",
      "block": "",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-xl-16"
  }, [_vm._v("응찰하기")])])], 1)]] : _vm._e()], 2)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }